module.exports = __webpack_public_path__ + "img/tutorial_calendar_02.2facf95d.gif";